// material
import { styled } from '@mui/material/styles';
import { Card, Stack, Link, Container, Typography, Button } from '@mui/material';
// layouts
import AuthLayout from '../layouts/AuthLayout';
// components
import Page from '../components/Page';
import { MHidden } from '../components/@material-extend';
import { LoginForm } from '../components/authentication/login';
import AuthSocial from '../components/authentication/AuthSocial';

import { Routes, Route, useParams, useLocation, useNavigate } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function Login() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { companyAccount, companyName, computerSN } = state;

  const backToCheckCompanyCode = () => {
    if (window.confirm('确定要切换公司吗？')) {
      reactLocalStorage.remove('localStorage_companyCode');
      console.log('backPage', 'checkCompanyCode');
      navigate("/checkCompanyCode", { replace: true, state: { computerSN } });
    }
  }

  return (
    <RootStyle title="Login | Minimal-UI">
      {/* <AuthLayout>
        Don’t have an account? &nbsp;
        <Link underline="none" variant="subtitle2" component={RouterLink} to="/register">
          Get started
        </Link>
      </AuthLayout> */}

      {/* <MHidden width="mdDown">
        <SectionStyle>
          <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
            Hi, Welcome Back
          </Typography>
          <img src="/static/illustrations/illustration_login.png" alt="login" />
        </SectionStyle>
      </MHidden> */}

      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 5 }}>
            <Stack direction='row' alignItems='center'>
              <Typography variant="h4" gutterBottom sx={{ flex: 1 }}>
                登录
              </Typography>
              <Typography variant="body2" gutterBottom sx={{ marginRight: '4px' }}>
                {companyName}
              </Typography>
              <Typography variant="body2" gutterBottom color='primary' sx={{ cursor: 'pointer' }} onClick={backToCheckCompanyCode}>
                [切换公司]
              </Typography>
            </Stack>
            <Typography sx={{ color: 'text.secondary' }}>在下面输入您的账号信息</Typography>
          </Stack>
          {/* <AuthSocial /> */}

          <LoginForm companyAccount={companyAccount} computerSN={computerSN} />

          {/* <MHidden width="smUp">
            <Typography variant="body2" align="center" sx={{ mt: 3 }}>
              Don’t have an account?&nbsp;
              <Link variant="subtitle2" component={RouterLink} to="register">
                Get started
              </Link>
            </Typography>
          </MHidden> */}
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
